/**
 * @generated SignedSource<<a177f34e9f23b9c5890fb7c9d6e1747a>>
 * @relayHash d96f78a849c08a644d7588600b73f9ef
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d96f78a849c08a644d7588600b73f9ef

import { ConcreteRequest } from 'relay-runtime';
export type Ch_updateProgressNoteAnamnesisInput = {
  anamnesis: string;
  id: string;
};
export type chUpdateProgressNoteAnamnesisMutation$variables = {
  input: Ch_updateProgressNoteAnamnesisInput;
};
export type chUpdateProgressNoteAnamnesisMutation$data = {
  readonly ch_updateProgressNoteAnamnesis: {
    readonly ch_ProgressNoteMutationOutput: {
      readonly episodeOfCare: {
        readonly id: string;
        readonly updatedAt: string;
      } | null;
      readonly progressNote: {
        readonly anamnesis: string | null;
        readonly updatedAt: string;
      };
    } | null;
  };
};
export type chUpdateProgressNoteAnamnesisMutation = {
  response: chUpdateProgressNoteAnamnesisMutation$data;
  variables: chUpdateProgressNoteAnamnesisMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_EpisodeOfCare",
  "kind": "LinkedField",
  "name": "episodeOfCare",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anamnesis",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdateProgressNoteAnamnesisMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateProgressNoteAnamnesisPayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNoteAnamnesis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ProgressNoteMutationOutput",
            "kind": "LinkedField",
            "name": "ch_ProgressNoteMutationOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUpdateProgressNoteAnamnesisMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateProgressNoteAnamnesisPayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNoteAnamnesis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ProgressNoteMutationOutput",
            "kind": "LinkedField",
            "name": "ch_ProgressNoteMutationOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v3/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d96f78a849c08a644d7588600b73f9ef",
    "metadata": {},
    "name": "chUpdateProgressNoteAnamnesisMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "529a266e8e9a12564aedfbab0e314894";

export default node;
